import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle, faMinus, faSitemap } from '@fortawesome/free-solid-svg-icons'
import './UserForm.css';
import Button from '../../components/Button/Button';

const UserOrganizationRoleMapping = ({ state, organizationData, orgRowChangeHandler, addOrgRow, removeOrgRow }) => {
  return (
    <div className="user-form-section">
      <div className="user-form-section-title">
        <span className="icon-badge"><FontAwesomeIcon icon={faSitemap} /></span>
        <span>Organization &amp; Role Mapping</span>
      </div>
      <div className="row">
        <div className="col-md-4">
          <label className="user-form-field-label">Organization</label>
        </div>
        <div className="col-md-4">
          <label className="user-form-field-label">Role</label>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          {state.organizations.map((val, idx) => {
            const selectedElsewhere = state.organizations
              .filter((_, otherIdx) => otherIdx !== idx)
              .map((org) => org.organization_id);
            const availableOrganizations = (organizationData || []).filter(
              (org) => !selectedElsewhere.includes(org.id) || org.id === val.organization_id,
            );
            return (
              <div className="row mb-3 align-items-start" key={idx}>
                <div className="col-md-4 user-form-field">
                  <select
                    name="organization_id"
                    data-id={idx}
                    className="form-select form-control cursor-pointer user-form-select"
                    value={val.organization_id}
                    onChange={(e) => orgRowChangeHandler(e, idx)}
                  >
                    <option value="">Choose Organization</option>
                    {availableOrganizations.map((org) => (
                      <option value={org.id} key={org.id}>
                        {org.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-4 user-form-field">
                  <select
                    name="role_id"
                    data-id={idx}
                    className="form-select form-control cursor-pointer user-form-select"
                    value={val.role_id}
                    onChange={(e) => orgRowChangeHandler(e, idx)}
                    disabled={!val.organization_id}
                  >
                    <option value="">
                      {val.organization_id ? "Choose Role" : "Select organization first"}
                    </option>
                    {(val.rolesData || []).map((role) => (
                      <option value={role.id} key={role.id}>
                        {role.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-4">
                  {idx === 0 ? (
                    <Button
                      variant="primary"
                      onClick={addOrgRow}
                      type="button"
                      className="text-center rounded-circle"
                      title="Add another organization"
                    >
                      <FontAwesomeIcon icon={faPlusCircle} />
                    </Button>
                  ) : (
                    <Button
                      variant="danger"
                      className="rounded-circle"
                      onClick={() => removeOrgRow(val)}
                      type="button"
                      title="Remove this row"
                    >
                      <FontAwesomeIcon icon={faMinus} />
                    </Button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default UserOrganizationRoleMapping;
